import { FunctionComponent } from "react";
import Button from "@mui/material/Button";
import DirectionsIcon from "@mui/icons-material/Directions";
import { buildGoogleMapsDirectionsUrl } from "../utils/calendarLinks";

interface GetDirectionsButtonProps {
  location: string;
  size?: "small" | "medium" | "large";
}

const GetDirectionsButton: FunctionComponent<GetDirectionsButtonProps> = ({ location, size = "small" }) => (
  <Button
    size={size}
    variant="outlined"
    startIcon={<DirectionsIcon fontSize="small" />}
    component="a"
    href={buildGoogleMapsDirectionsUrl(location)}
    target="_blank"
    rel="noopener noreferrer"
  >
    Get Directions
  </Button>
);

export default GetDirectionsButton;
